import PropTypes from 'prop-types';
import React from 'react';
import withRouter from 'react-router/lib/withRouter';
import _ from 'lodash';

import ModalStore from '../stores/ModalStore';
import { GlobalModals } from '../constants/AppConstants';
import connectToStores from '../helpers/connectToStores';
import { routerShape } from 'react-router/lib/PropTypes';

import PureRenderComponent from './PureRenderComponent';
import RegisterModal from './login/RegisterModal';
import LoginModal from './login/LoginModal';
import SmartcardModal from './account/SmartcardModal';
import ErrorModal from './general/ErrorModal';
import InfoModal from './general/InfoModal';
import ConfirmationModal from './general/ConfirmationModal';
import BasketModal from './booking/BasketModal';
import BasketExpiredModal from './booking/BasketExpiredModal';
import ForgotPasswordModal from './login/ForgotPassword';
import LoggedOutModal from './login/LoggedOutModal';
import LogoutWarningModal from './login/LogoutWarningModal';
import NRETransferModal from './nre/TransferModal';
import OrderStateErrorModal from './checkout/OrderStateErrorModal';
import InteropErrorModal from './checkout/InteropErrorModal';
import PromptPasswordChangeModal from './customer/PromptPasswordChangeModal';
import PassengerAssistBookingModal from './account/PassengerAssistBookingModal';
import { ChildSmartCardExpirationModal } from './customer/ChildSmartCardExpirationModal';
import AddReservationModal from './account/reservations/AddReservationModal';
import EmailConfirmationModal from './checkout/payment/EmailConfirmationModal';
import DuplicateOrderModal from './checkout/payment/DuplicateOrderModal';

const ModalComponents = {
    [ GlobalModals.REGISTER ]: React.createFactory(RegisterModal),
    [ GlobalModals.LOGIN ]: React.createFactory(LoginModal),
    [ GlobalModals.REGISTER_SMARTCARD ]: React.createFactory(SmartcardModal),
    [ GlobalModals.ERROR ]: React.createFactory(ErrorModal),
    [ GlobalModals.INFO ]: React.createFactory(InfoModal),
    [ GlobalModals.BASKET ]: React.createFactory(BasketModal),
    [ GlobalModals.BASKET_EXPIRED ]: React.createFactory(BasketExpiredModal),
    [ GlobalModals.FORGOT_PASSWORD ]: React.createFactory(ForgotPasswordModal),
    [ GlobalModals.LOGGED_OUT ]: React.createFactory(LoggedOutModal),
    [ GlobalModals.LOGOUT_WARNING ]: React.createFactory(LogoutWarningModal),
    [ GlobalModals.NRE ]: React.createFactory(NRETransferModal),
    [ GlobalModals.ORDER_STATE_ERROR ]: React.createFactory(OrderStateErrorModal),
    [ GlobalModals.INTEROP_ERROR ]: React.createFactory(InteropErrorModal),
    [ GlobalModals.CONFIRM ]: React.createFactory(ConfirmationModal),
    [ GlobalModals.PROMPT_PASSWORD_CHANGE ]: React.createFactory(PromptPasswordChangeModal),
    [ GlobalModals.BOOK_PASSENGER_ASSIST ]: React.createFactory(PassengerAssistBookingModal),
    [ GlobalModals.CHILD_SMART_CARD_EXPIRATION ]: React.createFactory(ChildSmartCardExpirationModal),
    [ GlobalModals.RESERVATIONS ]: React.createFactory(AddReservationModal),
    [ GlobalModals.CONFIRM_EMAIL ]: React.createFactory(EmailConfirmationModal),
    [ GlobalModals.DUPLICATE_ORDER ]: React.createFactory(DuplicateOrderModal),
};

function _stateFromStores () {
    return {
        active: ModalStore.getActive(),
        data: ModalStore.getData()
    };
}

@withRouter
@connectToStores([ ModalStore ], _stateFromStores)
class GlobalModalsComponent extends PureRenderComponent {

    static propTypes = {
        router: routerShape,
        active: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.func
        ]),
        data: PropTypes.any
    };

    render () {
        const { active, data, router } = this.props;

        if (!active) {
            return null;
        }

        const props = Object.assign({ router }, data);

        if (_.isFunction(active)) {
            return React.createFactory(active)(props);
        }
        return ModalComponents[active](props);
    }
}

export default GlobalModalsComponent;
